import React, { Component } from "react";
import * as Survey from "survey-react";

import "survey-react/survey.css";
import "./Survey.css";

import {
  changeArt,
  downloadFile,
  getData,
  getPartialData,
  saveData,
  savePartialData,
  uploadFile,
  uploadReceipt
} from '../api/api';
import PopUp from "./PopUp";
import PopUpInfo from "./PopUpInfo"

Survey.StylesManager.applyTheme("orange");

class SurveyComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      welcomeBlock: true,
      showPopup: false,
      showPopupInfo: false,
      popUpInfoText: '',
      popUpInfoTitle: '',
      currentValue: null,
      previousValue: null,
      error: false,
      json: null,
      originalJson: null,
      changedJson: null,
      isJsonDataFull: true,
      user: JSON.parse(localStorage.getItem('user'))
    }
    this.getInfoResponse = this.getInfoResponse.bind(this);
    this.changeData = this.changeData.bind(this);
    this.onAfterComplete = this.onAfterComplete.bind(this);
  }

  async componentDidMount() {
    try {
      let response = await getData();
      let prevData = await this.getPrevData();

      if (response === 401) {
        this.props.logout();
      }
      if (response === 'connection_failed' || prevData === 'connection_failed') {
        this.setState({ error: true });
      } else {
        this.setState({ json: response, originalJson: response, prevData });
      }
    } catch (e) {
      console.error(e)
    }
  }
  // Help popup text
  async showDescription(element, page, data) {
    // save/get current prev data for current page
    await savePartialData(data);
    let prev = await this.getPrevData();

    // cut (abschnitt) from title
    let splitted = element.title.slice(0, -1).split("(").pop().replace(/[()]/g, '');

    this.setState({
      popUpInfoText: element.popupdescription,
      popUpInfoTitle: splitted,
      showPopupInfo: true,
      prevData: { ...prev, pageNo: page }
    })
    this.forceUpdate();
  }

  // get partial Data, previously saved
  async getPrevData() {
    const prevDataFromBE = await getPartialData()
    if (prevDataFromBE !== 'connection_failed' && prevDataFromBE && Object.keys(prevDataFromBE).length > 0) {
      return prevDataFromBE
    }
    return null
  }

  // 'Wollen Sie korregieren' 'Ja' response from Info Block, if 'Ja' - edit survey
  getInfoResponse(response) {
    this.setState({ editBlock: response });
  }
  // close popup for dropdown on change 'Art der Einrichtung'
  closePopUp = (showPopUp, previousValue) => {
    const prevValue = this.state.prevData;
    prevValue.Form_Einrichtung_Art = previousValue
    this.setState({ showPopup: showPopUp, showPopupInfo: showPopUp, prevData: prevValue });
  }
  // set new Value for Dropdown 'Art der Einrichtung' - 'Bestätigen' click
  changeValuePopUp = async (showPopUp, currentValue) => {
    // modify prev data
    const prevValue = this.state.prevData;
    prevValue.Form_Einrichtung_Art = currentValue
    // remove all answers except vorFragen - clear prev data on Art value change
    for (let key in prevValue) {
      if (Number(key)) {
        delete prevValue[key];
      }
    }
    // get new questions for changed art
    if (!(prevValue.vorFrage1 === "Nein")) {
      const newData = await changeArt(currentValue);
      this.setState({ showPopup: showPopUp, prevData: prevValue, json: newData });
    }else{
      //just change art and dont do anything with response when its a short survey
      await changeArt(currentValue);
      this.setState({ showPopup: showPopUp, prevData: prevValue});
    }
    
  }

  // onValueChange
  changeData(name, value, senderData, page) {
    // handle dropdown change
    const prevValue = this.state.prevData.Form_Einrichtung_Art
    if (name === 'Form_Einrichtung_Art' && value && prevValue !== value) {
      this.setState({
        currentValue: value,
        previousValue: prevValue,
        showPopup: true,
        prevData: { ...this.state.prevData, ...senderData, pageNo: page }
      });
      this.forceUpdate();
    }
    // if user chooses 'no' for 1st question or 'yes' for all questions on 1st page, he should have only 2 steps
    // only for 1st page
    if (page === 0) {
      // define cases in which user should have 2 steps
      const isFirstPrevQuestionNo = name === 'vorFrage1' && value === 'Nein'
      const isFourthPrevQuestionYes = value === 'Ja' &&
        senderData.vorFrage1 === 'Ja' &&
        senderData.vorFrage1a === 'Ja' &&
        senderData.vorFrage1b === 'Ja' &&
        senderData.vorFrage1c === 'Ja'
      // define cases in which all steps should be restored (if they had been cut before)
      const isFirstPrevQuestionYesAgain = name === 'vorFrage1' && value === 'Ja' && !this.state.isJsonDataFull
      const isOneOfQuestionsNoAgain = value === 'Nein' && name !== 'vorFrage1' && !this.state.isJsonDataFull

      if (isFirstPrevQuestionNo) {
        // copy original obj avoiding mutation
        const changedJson = JSON.parse(JSON.stringify(this.state.originalJson))
        // cut original json to 4 questions & set it to state
        changedJson.pages.length = 1
        // add data to prev data to store after rendering
        this.setState({
          json: { ...changedJson },
          isJsonDataFull: false,
          prevData: { ...this.state.prevData, ...senderData, pageNo: 0 }
        });
      }
      if (isFourthPrevQuestionYes) {
        // copy original obj avoiding mutation
        const changedJson = JSON.parse(JSON.stringify(this.state.originalJson))
        // cut original json to 4 questions & set it to state
        changedJson.pages.length = isFirstPrevQuestionNo ? 3 : 2
        // add data to prev data to store after rendering
        this.setState({
          json: { ...changedJson },
          isJsonDataFull: false,
          prevData: { ...this.state.prevData, ...senderData, pageNo: 0 }
        });
      } else if (isFirstPrevQuestionYesAgain || isOneOfQuestionsNoAgain) {
        // in case if user changes his answers => restore original full json in state
        // return original full json to state
        this.setState({
          json: { ...this.state.originalJson },
          isJsonDataFull: true,
          prevData: { ...this.state.prevData, ...senderData, pageNo: 0 }
        });
      }
    }
  }
  // show text after complete
  onAfterComplete() {
    const { logout } = this.props
    logout(true);
  }

  render(sender, options) {
    let survey = new Survey.Model(this.state.json);
    let state = this.state;
    let prevData = this.state.prevData;

    // check if there is previous data
    if (prevData && Object.keys(prevData).length > 0) {
      survey.data = prevData;
      if (prevData.pageNo) {
        survey.currentPageNo = prevData.pageNo;
      }
      if (survey.currentPageNo === 0 && prevData.vorFrage1 === 'Nein' && this.state.isJsonDataFull) {
        this.changeData('vorFrage1', 'Nein', {}, 0)
      }
      if ((survey.currentPageNo === 0 && (
        prevData.vorFrage1 === 'Ja' && prevData.vorFrage1a === 'Ja' && prevData.vorFrage1b === 'Ja' && prevData.vorFrage1c === 'Ja'))
        && this.state.isJsonDataFull) {
        const obj = {
          vorFrage1a: 'Ja',
          vorFrage1b: 'Ja',
          vorFrage1c: 'Ja',
          vorFrage1: 'Ja',
        }
        this.changeData('vorFrage1', 'Ja', obj, 0)
      }
    }
    // help popup
    Survey
      .Serializer
      .addProperty("question", "popupdescription:text");
    survey
      .onGetQuestionTitleActions
      .add((_, opt) => {
        if (opt.question.popupdescription) {
          opt.titleActions = [
            {
              title: `Hilfe`,
              innerCss: 'btn-help',
              action: () => {
                this.showDescription(opt.question, _.currentPageNo, _.data);
              }
            }
          ];
        }
      });

    // save data
    async function saveSurveyData(survey, partialSave = false) {
      let data = survey.data;
      data.pageNo = survey.currentPageNo;
      // save the last page of survey to load it on render when prev data come in
      if (partialSave === true) {
        await savePartialData(data);
      } else {
        await saveData(data);
      }
    }
    // logout after complete
    const afterComplete = () => {
      this.onAfterComplete();
    }
    // on partial data save - 'weiter' click
    survey.onPartialSend.add(async function (survey) {
      await saveSurveyData(survey, true);
    });
    // on complete data save - 'abschließen' click
    survey.onComplete.add(async function (survey) {
      await saveSurveyData(survey);
      afterComplete();
      //this.props.logout(true);
    });
    // emit event on any value change
    survey.onValueChanged.add(async (sender, options) =>
      this.changeData(options.name, options.value, sender.data, survey.currentPageNo)
    );
    // on File upload
    survey
      .onUploadFiles
      .add(async function (survey, options) {
        if (options.name === 'Form_Qualitaetssicherung_Beleg1' || options.name === 'Form_Qualitaetssicherung_Beleg2' || options.name === 'Form_Qualitaetssicherung_Beleg3') {
          await uploadReceipt(survey, options);
        } else {
          await uploadFile(survey, options);
        }
      });
    // on download File
    survey
      .onDownloadFile
      .add(async function (survey, options) {
        await downloadFile(options, state.user.token);
      });

    // on preview - show button at the top + info text
    survey.registerFunctionOnPropertyValueChanged(
      "isShowingPreview",
      () => {
        if (survey.isShowingPreview) {
          // show button at the top
          survey.showNavigationButtons = "both";
        } else {
          survey.showNavigationButtons = "bottom";
        }
      }
    )
    // show info text on preview
    survey.onShowingPreview.add(() => {
      // remove hilfe btn
      survey
        .onGetQuestionTitleActions
        .add((_, opt) => {
          if (opt.question.popupdescription) {
            opt.titleActions = [];
          }
        });
      // show info text in preview header
      setTimeout(() => {
        const allDivs = document.getElementsByClassName("sv_nav")
        const navDiv = allDivs[0]
        const text = document.createElement("span")
        text.innerHTML = "Hier nochmal eine Zusammenfassung Ihrer Antworten. Wenn Sie Ihre Antworten bearbeiten möchten, können Sie dies hier ein allerletztes mal tun. Danach gibt es dazu keine Möglichkeit mehr, deshalb sollten Sie sorgfältig kontrollieren. " +
          "Wenn Sie fertig sind, klicken Sie bitte auf Abschließen.<br/>" +
          "Wenn Sie als Nachweis eine PDF drucken möchten, nutzen Sie bitte die Druckfunktion des Browsers."
        text.classList.add("preview_text")
        navDiv.appendChild(text);
      }, 100)
    })

    // customise library CSS with own classes
    survey.css = {
      page: {
        title: "questionTitle",
        description: "description"
      },
      matrixdynamic: {
        headerCell: "cellTitle"
      }
    };
    // customise library settings
    survey.locale = "de";
    survey.requiredText = "";
    survey.showProgressBar = 'bottom';
    survey.sendResultOnPageNext = true;
    survey.showPreviewBeforeComplete = 'showAnsweredQuestions';
    survey.showCompletedPage = false;

    return (
      <div>
        <div className="content">
          <h2 style={{ color: "dimgray" }}>Qualitätsbericht Hämotherapie</h2>
          {/* server error info */}
          {this.state.error && (<div style={{ color: "red" }}>CONNECTION ERROR</div>)}
          {/* Survey.js Library Component */}
          {
            !this.state.editBlock && (this.state.json != null) ?
              <Survey.Survey
                model={survey}
              /> : null
          }
          {/* Popup window on dropdown change - Art der Einrichtung */}
          <PopUp showPopUp={this.state.showPopup}
            currentValue={this.state.currentValue}
            previousValue={this.state.previousValue}
            closePopUp={this.closePopUp}
            changePopUp={this.changeValuePopUp}
          />
          <PopUpInfo
            key={this.state.popUpInfoText + this.state.popUpInfoTitle}
            showPopUp={this.state.showPopupInfo}
            closePopUp={this.closePopUp}
            text={this.state.popUpInfoText}
            title={this.state.popUpInfoTitle}
          />
        </div>
      </div>
    );
  }
}

export default SurveyComponent;
